import { useContext } from "react";
import { forgotPassword, forgotPasswordByCuit } from "../../../services/services";
import AuthHeader from "../../authentication/authHeader";
import FormInputItem, {
	forgotPasswordFormItems,
} from "../../common/form/formInput/formInput";
import FormButton from "./../../common/form/formButton";
import FormNavigate from "./../../common/form/formNavigate";
import ForgotPasswordFormStep from "./../forgotPasswordFormStep/forgotPasswordFormStep";
import { ForgotPasswordContext } from "../../../context/forgotPasswordContext";

const EmailFormHeader = ({recoveryByCuit}) => {
    return (
        <AuthHeader title='Olvidaste la contraseña?'>
            <p className='forgotPassword-text'>
				{!recoveryByCuit ? 
				"Recibirás un código a la dirección de correo especificada para poder reestablecerla" 
			   :"Recibirás un código a la dirección de correo registrada con el CUIT para poder reestablecerla"}
            </p>
        </AuthHeader>
    );
};

const EmailForm = () => {
    const { recoveryByCuit, setRecoveryByCuit, changeValue } = useContext(ForgotPasswordContext);

    const sendCodeEmail = (values) => forgotPassword(values.email);
	const sendCodeCuit = (values) => forgotPasswordByCuit(values.cuit);

    const handleOnChange = (e) => changeValue(e.target.value);


	const [emailInputItem, cuitInputItem] = forgotPasswordFormItems
    return (
        <ForgotPasswordFormStep
            FormStepHeader={<EmailFormHeader recoveryByCuit={recoveryByCuit} />}
            formStepCallback={recoveryByCuit ? sendCodeCuit : sendCodeEmail}
        >
            <div style={{ width: "350px" }}>
				{recoveryByCuit ?	 (
						<FormInputItem
							item={cuitInputItem}
							onChange={handleOnChange}
						/>
				) : (
						<FormInputItem
							item={emailInputItem}
							onChange={handleOnChange}
						/>
				)}
                <FormButton>Enviar</FormButton>
            </div>
			
            <div>
				{recoveryByCuit ? (
					<p  style={{cursor: "pointer", color: "#1677ff", textAlign: "center"}} onClick={() => setRecoveryByCuit(false)} >Recuperar contraseña ingresando el Email</p>
				) : (
					<p style={{cursor: "pointer", color: "#1677ff", textAlign: "center"}}onClick={() => setRecoveryByCuit(true)}>Recuperar contraseña ingresando el CUIT</p>
				)}
                <FormNavigate url='/login'>Volver al Login</FormNavigate>
            </div>
        </ForgotPasswordFormStep>
    );
};

export default EmailForm;
